export default {
      id: "common__complex-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__complex",
      toString: function () {
        return this.url;
      }
    }